import { IEventsStore } from '../index'

export default function(state: IEventsStore): IEventsStore {
  return {
    ...state,
    eventId: '',
    pdf: '',
  }
}
